import styled from '@emotion/styled'

export const Container = styled.div<{inverse?: boolean}>`
  align-items: center;
  display: flex;
  flex-direction: ${props => props.inverse ? 'row-reverse' : 'row'};
  gap: 1rem;
`
